import React, { useState, useEffect } from "react";
import { socketDeposits } from "../../Sockets/DepositsSocket.js";
import { SocketMessages } from "../../enums/SocketMessages.js";
import { Grid } from "@mui/material";
import CryptoSelect from "./CryptoSelect";
import DepositAddressStep from "./DepositAddressStep";
import CheckDeposit from "./CheckDeposit";
import DepositVerified from "./DepositVerified";
import { useParams } from "react-router";

const DepositAgent = ({ token, id }) => {
	const params = useParams();
	const [step, setStep] = useState(1);
	const { crypto, net } = params;
	const [cryptoCurrency, setCryptoCurrency] = useState(crypto ?? null);
	const [network, setNetwork] = useState(net ?? null);
	const [address, setAddress] = useState(null);
	const [agreement, setAgreement] = useState(false);
	const [isConnected, setIsConnected] = useState(false); //socketDeposits.connected);
	const [deposit, setDeposit] = useState(null);

	console.log("token main deposit", token);

	useEffect(() => {
		const onConnect = () => {
			setIsConnected(true);
		};

		const onDisconnect = () => {
			setIsConnected(false);
		};

		const onDepositReceived = (data) => {
			console.log("SOCKET RECEIVED ", data);
			if (data.agent?.toString() === id.toString()) {
				setDeposit(data);
				if (data.isProcessed === true) {
					setStep(4);
				}
			}
		};

		socketDeposits.on(SocketMessages.CONNECT, onConnect);
		socketDeposits.on(SocketMessages.DISCONNECT, onDisconnect);
		socketDeposits.on(SocketMessages.DEPOSITS, onDepositReceived);

		// Connect the socket when the component mounts
		socketDeposits.connect();

		// Clean up the event listeners and disconnect when the component unmounts
		return () => {
			socketDeposits.off(SocketMessages.CONNECT, onConnect);
			socketDeposits.off(SocketMessages.DISCONNECT, onDisconnect);
			socketDeposits.disconnect(); // Disconnect to prevent memory leaks and unnecessary connections
		};
	}, []);

	if (step === 1) {
		return (
			<Grid container sx={{ justifyContent: "center", alignContent: "center", textAlign: "center" }}>
				<CryptoSelect
					title={"Deposit Crypto"}
					setCryptoCurrency={setCryptoCurrency}
					cryptoCurrency={cryptoCurrency}
					network={network}
					setNetwork={setNetwork}
					setStep={setStep}
					token={token}
				/>
			</Grid>
		);
	}
	if (step === 2) {
		return (
			<Grid container sx={{ justifyContent: "center", alignContent: "center", textAlign: "center" }}>
				<DepositAddressStep
					cryptoCurrency={cryptoCurrency}
					network={network}
					title={`${cryptoCurrency} Deposit`}
					setStep={setStep}
					agreement={agreement}
					address={address}
					setAddress={setAddress}
					setAgreement={setAgreement}
					token={token}
				/>
			</Grid>
		);
	}
	if (step === 3) {
		return (
			<Grid container sx={{ justifyContent: "center", alignContent: "center", textAlign: "center" }}>
				<CheckDeposit
					cryptoCurrency={cryptoCurrency}
					network={network}
					title={`${cryptoCurrency} Deposit`}
					setStep={setStep}
					deposit={deposit}
				/>
			</Grid>
		);
	}
	if (step === 4) {
		return (
			<Grid container sx={{ justifyContent: "center", alignContent: "center", textAlign: "center" }}>
				<DepositVerified
					cryptoCurrency={cryptoCurrency}
					network={network}
					title={`${cryptoCurrency} Deposit`}
					setStep={setStep}
					deposit={deposit}
				/>
			</Grid>
		);
	}
};

export default DepositAgent;
